<template>
  <root :page-data="pageList" />
</template>
<script>
import Vue from 'vue'
import install from './index.js'
import Root from './../../components/root.vue'
install(Vue)
export default {
    name: 'Default',
    'components': { Root },
    data() {
        return {
            pageList: [{"id":"page1","name":"page1","options":{"basic":{"layoutType":"static","showPage":true,"pageRouter":""},"style":{"height":"10.706666666666667rem","background":{"color":"transparent","image":"","repeat":"no-repeat","size":"cover","position":"center","origin":""}},"animation":{}},"components":[{"basic":{"COLOGID":"hxDbiqc83","url":"https://web-static.didachuxing.com/pics/g/xscsakm39s0E7cABK99vE7b82bB9BE6J8BsBC9E8JBDrA6xE8iAEUA18E8CB4dB9nE5c85EACfE5qBCy8F.png","repeat":"no-repeat","size":"contain","position":"center","origin":"","imgKey":""},"show":true,"lock":false,"name":"图片组件","style":{"rect":{"x":"1.72rem","y":"2.08rem","w":2,"h":10.706666666666667,"a":1,"r":0,"l":0,"b":0,"t":0}},"id":"hxDbiqc83","type":"mars-image"}]},{"id":"fixed1","name":"fixed page","options":{"basic":{"layoutType":"fixed","showPage":true,"pageRouter":""},"style":{"height":8.893333333333333,"background":{"color":"transparent","image":"","repeat":"no-repeat","size":"cover","position":"center","origin":""}},"animation":{}},"components":[]}]
        }
    }
}
</script>